import React from 'react'
import { Button, Card } from 'react-bootstrap';
import { getBankData, getUserData } from '../../utils/common';
import { userDataProps } from '../../App';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

interface userManualProps {
    flag?: string
}

const UserMannual: React.FC<userManualProps> = ({ flag }) => {

    const bankDtl: any = getBankData();
    const userData: userDataProps = getUserData();
    const navigate = useNavigate();

    return (
        <>
            <div className="mb-3 d-flex align-items-center">
                <h2 className="text-base fw-semibold mb-0">Complaint Management System User Manual</h2>
                {flag === "L" &&
                    <Button variant="outline-secondary ms-auto" className="btn-sm" onClick={() => navigate("/")}>
                        <BiArrowBack className="me-2" />
                        Back
                    </Button>
                }
            </div>

            <Card className='user-mannual px-md-5 px-auto'>
                <Card.Body>
                    <div className="section-title">
                        <h4>About It</h4>
                    </div>

                    <p>The Complaint Management System (CMS) introduced by <strong>{userData?.BankName}</strong> is a major
                        advancement in delivering faster and more transparent service to our customers. The platform is designed to
                        automate and improve the process of complaint resolution from start to finish — receiving, registering,
                        tracking, and resolving issues efficiently.</p>

                    <p>With CMS, each customer concern is acknowledged and addressed systematically, helping us build stronger,
                        trust-based relationships. This upgrade aligns with our commitment to continuous improvement and reflects
                        our motto: <em>"Our Oath, Your Growth."</em></p>

                    <div className="section-title">
                        <h4>Benefits of the CMS</h4>
                    </div>
                    <ul>
                        <li><strong>Faster Resolution:</strong> Complaints are tracked in real-time for quicker responses.</li>
                        <li><strong>Transparency:</strong> Customers can monitor their complaint status anytime.</li>
                        <li><strong>Better Decision-Making:</strong> Data from complaints reveals patterns for internal
                            improvements.</li>
                        <li><strong>Higher Satisfaction:</strong> Efficient service equals happier customers.</li>
                    </ul>

                    <p>We’re committed to providing the best possible banking experience. CMS is a step toward greater transparency,
                        responsiveness, and accountability.</p>

                    <div className="section-title">
                        <h4>Topics</h4>
                    </div>

                    <table className="table table-bordered table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">Sr. No</th>
                                <th scope="col">Topic Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Customer Login Portal – Home Page</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Customer Login Portal (Enter Mobile No)</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Registration Page</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>OTP Generation</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Login Portal Dashboard View</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Create Ticket</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>All Ticket Track View</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Announcement</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Circular</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* <!-- Each section follows below --> */}

                    <ol>
                        {bankDtl?.ClientLoginType !== "Y" ?
                            <>
                                <li>
                                    <div className="section-title">
                                        <h4>Customer Login Portal – Home Page</h4>
                                    </div>
                                    <p>Users enter their registered mobile number here. This page is open to customers and non-customers.</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/login.jpeg"} alt="Login Page" />
                                </li>

                                <li>
                                    <div className="section-title">
                                        <h4>Enter Mobile Number</h4>
                                    </div>
                                    <p>Entering a valid mobile number is the first mandatory step in the login process.</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/login.jpeg"} alt="Mobile Input" />
                                </li>

                                <li>
                                    <div className="section-title">
                                        <h4>Registration Page</h4>
                                    </div>
                                    <p>New users must provide details such as Name, Email, and Mobile Number to complete registration.</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/register.png"} alt="Registration" />
                                </li>
                            </> : <>
                                <li>
                                    <div className="section-title">
                                        <h4>Customer Login Portal – Home Page</h4>
                                    </div>
                                    <p>Users enter their username and password here.</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/userPassLogin.png"} alt="Login Page" />
                                </li>

                                <li>
                                    <div className="section-title">
                                        <h4>Enter Username and Password</h4>
                                    </div>
                                    <p>Entering a valid username and password is the first mandatory step in the login process.</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/userPassLogin.png"} alt="Mobile Input" />
                                </li>

                                <li>
                                    <div className="section-title">
                                        <h4>Registration Page</h4>
                                    </div>
                                    <p>New users must provide details such as Username, Email, Person Name and Mobile Number to complete registration. password is send after request approve from admin penal</p>
                                    <img className="img-fluid rounded" src={"/imgaes/screenImg/userPassRegister.png"} alt="Registration" />
                                </li>
                            </>}

                        {bankDtl?.ClientOrgShow === "Y" &&
                            <li>
                                <div className="section-title">
                                    <h4>Select Organization Page</h4>
                                </div>
                                <p>New users must provide organization</p>
                                <img className="img-fluid rounded" src={".png/imgaes/screenImg/selectOrg.png"} alt="Registration" />
                            </li>
                        }

                        <li>
                            <div className="section-title">
                                <h4>OTP Generation</h4>
                            </div>
                            <p>After registration, an OTP is sent to the mobile number. Entering this OTP completes the login process.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/otp.png" alt="OTP Page" />
                        </li>
                        <li>
                            <div className="section-title">
                                <h4>Login Portal Dashboard</h4>
                            </div>
                            <p>Users can see the status of all their complaints — Open, In-Process, Closed, or Reopened.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/dashboard.png" alt="Dashboard" />
                        </li>
                        <li>
                            <div className="section-title">
                                <h4>Create Ticket</h4>
                            </div>
                            <p>Customers can log a new complaint by selecting the issue and submitting a request, after which a ticket
                                number is generated.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/createticket.png" alt="Add Ticket" />
                        </li>
                        <li>
                            <div className="section-title">
                                <h4>Ticket Status View</h4>
                            </div>
                            <p>All tickets with their current status are viewable on a single screen for better tracking.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/ticketList.png" alt="Ticket Tracking" />
                        </li>
                        <li>
                            <div className="section-title">
                                <h4>Announcements</h4>
                            </div>
                            <p>Stay updated with all recent announcements by the bank, whether temporary or permanent.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/announcement.png" alt="Announcements" />
                        </li>
                        <li>
                            <div className="section-title">
                                <h4>Circular</h4>
                            </div>
                            <p>Stay updated with all recent circular by the bank, whether temporary or permanent.</p>
                            <img className="img-fluid rounded" src="/imgaes/screenImg/circuler.png" alt="Announcements" />
                        </li>
                    </ol>

                </Card.Body>
            </Card>
        </>
    )
}

export default UserMannual